/**
 * The filters one can choose from in the detailed view
 */
import React from 'react'
import Tappable from 'react-tappable/lib/Tappable';
import SelectorActions from '../../../actions/selector-actions'
import thumbNone from '../../../../assets/images/panorama-thumb56-none.jpg'
import thumbBlackWhite from '../../../../assets/images/panorama-thumb56-blackwhite.jpg'
import thumbSephia from '../../../../assets/images/panorama-thumb56-sephia.jpg'
import createReactClass from 'create-react-class'


	var filterData = [
		{
			'label' : 'Original',
			'value' : 'none',
			'img'   : thumbNone
		},
		{
			'label' : 'B/W',
			'value' : 'BlackWhite',
			'img'	: thumbBlackWhite
		},
		{
			'label' : 'Sephia',
			'value' : 'Sephia',
			'img'	: thumbSephia
		}/*, These have been turned off because we don't have a design that works well with many filters.
		{
			'label' : 'Inkwell',
			'value' : 'Inkwell'
		},
		{
			'label' : 'Mayfair',
			'value' : 'Mayfair'
		},
		{
			'label' : 'Amaro',
			'value' : 'Amaro'
		},
		{
			'label' : 'Rise',
			'value' : 'Rise'
		},
		{
			'label' : 'Hudson',
			'value' : 'Hudson'
		},
		{
			'label' : 'Valencia',
			'value' : 'Valencia'
		},
		{
			'label' : 'XProll',
			'value' : 'XProll'
		},
		{
			'label' : 'Sierra',
			'value' : 'Sierra'
		},
		{
			'label' : 'Willow',
			'value' : 'Willow'
		},
		{
			'label' : 'LoFi',
			'value' : 'LoFi'
		},
		{
			'label' : 'Earlybird',
			'value' : 'Earlybird'
		},
		{
			'label' : 'Sutro',
			'value' : 'Sutro'
		},
		{
			'label' : 'Toaster',
			'value' : 'Toaster'
		},
		{
			'label' : 'Brannan',
			'value' : 'Brannan'
		},
		{
			'label' : 'Walden',
			'value' : 'Walden'
		},
		{
			'label' : 'Hefe',
			'value' : 'Hefe'
		},
		{
			'label' : 'Nashville',
			'value' : 'Nashville'
		},
		{
			'label' : 'Year1997',
			'value' : 'Year1997'
		},
		{
			'label' : 'Kelvin',
			'value' : 'Kelvin'
		}*/
	];

var DetailedFilters = createReactClass({
	getDefaultProps: function() {
		return {
			item: null
		}
	},
	shouldComponentUpdate: function(prevProps) {
		return true;
	},

	applyFilter: function (filterId) {
		this.props.callback(filterId);
	},

	render: function() {
		var instance = this,
			options = this.props.item ? this.props.item.options : null,
			filters = filterData.map(function(filter, i) {
				var className = 'ope-filter__option ';
				if(options) { //The filter is for a single item
					if(typeof options.imageFilter.effects !== 'undefined' && options.imageFilter.effects.length > 0) {
						if(filter.value === options.imageFilter.effects[0].type) {
							className += ' ope-filter__option--selected';
						}
					}
					// Else add selected to the "Original" effect
					else if(filter.value == 'none') {
						className += ' ope-filter__option--selected';
					}
				} else { //The filter select is for multiple items
					if (filter.value == instance.props.batchFilterSelected) {
						className += ' ope-filter__option--selected';
					}
				}
				return (
					<li key={i} className={className}>
						<Tappable onTap={instance.applyFilter.bind(instance, filter.value)}>
							<span>
								<div className="ope-filter__option__thumbnail">
									<img src={filter.img} />
								</div>
								<span className="ope-filter__option__label">{_(filter.label)}</span>
							</span>
						</Tappable>
					</li>
				);
			});

		return (
			<div className="ope-editor__detailed__filters ope-filter">
				<ul>
					{ filters }
				</ul>
			</div>
		);
	}
});

export default DetailedFilters;
